import zenscroll from 'zenscroll';

// Custom global scripts
jQuery(document).ready(function ($) {
    'use strict';

    // Foundation Init
    $(document).foundation();

    if (window.location.pathname.search('about-us') !== -1) {
        $('a[href^="/about-us"]:not([href="/about-us"])').each(function () {
            let attr = this.getAttribute('href').split('/about-us#section-')[1];
            $(this).attr('href', `#${attr}`);
        });
    }

    var defaultDuration = 777 // ms
    var edgeOffset = 119 // px
    zenscroll.setup(defaultDuration, edgeOffset)

    if (window.location.hash && window.location.pathname === '/about-us/' || window.location.hash && window.location.pathname === '/our-work/') {
        var target = $(window.location.hash);
        target = target.length ? target : $(`[data-id=${window.location.hash}]`);
        let target = '';
        if (window.location.hash && window.location.hash.includes('-')) {
            let arr = window.location.hash.split('-');
            arr.shift();
            let targetString = arr.join('-');
            target = $(`section[data-id="${targetString}"]`)[0];
        }
        // Does a scroll target exist?
        if (target) {
            setTimeout(function () {
                zenscroll.to(target);
            }, 750);
        }
    }

    $('a[href^="#"]:not([href="#"])').click(function (e) {
        e.preventDefault();
        let targString = $(e.target).attr('href').split('#')[1];
        zenscroll.to($(`section[data-id="${targString}"]`)[0]);
    })

    $('.reveal--flag').on('open.zf.reveal', function (e) {
        e.target.parentNode.scrollTop = 0;
    });

    // Mobile nav toggle
    $('#nav-mobile-toggle').on('click', function () {
        $('#nav-mobile').slideToggle();
    });

    $('.sub-menu').siblings('a').on('mouseover', function () {
        if (!$(this).closest('li').hasClass('open')) {
            $(this).siblings('.sub-menu').slideToggle();
            $(this).closest('li').toggleClass('open');
        }
    });

    $('.sub-menu').closest('li').on('mouseleave', function () {
        $(this).children('.sub-menu').slideToggle();
        $(this).toggleClass('open');
    });

    $('.search-menu-toggle').children('a').on('click', function () {
        $(this).siblings('.search-form-container').animate({
            width: 'toggle'
        });
        $(this).toggleClass('open');
    });

    //$('#nav-main').children('li:last-child').children('a').addClass('button button--wide-6 text--upper');

    //$('.nav-main-wrap').children('li:last-child').appendTo('#nav-main');

    $(window).scroll(function () {
        // Set a point that is 3/4 the px height of the first section
        let scrollCalc = ($('section')[0].getBoundingClientRect().bottom - $('section')[0].getBoundingClientRect().top) * .75;
        // Leave a 100px buffer to avoid jankiness
        if (window.scrollY > scrollCalc) {
            if (!$('.site-header').hasClass('sticky')) {
                $('.site-header').addClass('sticky');
                $('.site-header .alt-logo').animate({
                    opacity: 1
                });
            }
        } else if (window.scrollY === 0) {
            if ($('.site-header').hasClass('sticky')) {
                $('.site-header').removeClass('sticky');
                $('.site-header .alt-logo').animate({
                    opacity: 0
                });
            }
        }
    });

    wait('button.alm-load-more-btn', 100, 0, 50, () => {
        setTimeout(() => {
            $('button.alm-load-more-btn').click();
        }, 250);
    });

    if ($('.donate-grid').length > 0) {
        $('.donate-grid').find('.donate-grid__button').each(function () {
            $(this).click(function(e) {
                e.preventDefault();
                $('.donate-grid .donate-grid__button').not(this).removeClass('active');
                $(this).toggleClass('active');
            });
        });
    }

    if ($('#nav-main li').length > 0) {
        $('#nav-main li.current-menu-item a.button').each(function () {
            $(this).closest('li').removeClass('current-menu-item');
        });
    }

    $('.reveal-overlay').css('z-index', '1000');

    var buttonFrequency = $('.js--frequency'),
        buttonAmount    = $('.js--amount'),
        customAmount 	= $('.js--custom-amount'),
        buttonDonate    = $('.js--button-donate'),
        email 			= $('.js--email');

    // Toggling frequency
    buttonFrequency.on('change', function(e) {
        if (e.target.checked) {
            buttonFrequency.attr('data-frequency', 'month');
        } else {
            buttonFrequency.attr('data-frequency', 'one-time');
        }
    });

    // Toggling amount
    buttonAmount.on('click', function(e) {
        e.preventDefault();
        $('.js--amount').removeClass('active');
        $('.js--custom-amount').val("");
        $(this).toggleClass('active');
    });

    // Resetting amounts and setting the custom-amount
    customAmount.on('change', function() {
        $('.js--amount').removeClass('active');
    });

    buttonDonate.on( 'click', function(e) {
        e.preventDefault();
        var amountInput 	= customAmount.val();
        var amountButton 	= $('.js--amount.active').data('amount');
        var amount 			= amountInput != '' ? amountInput : amountButton;
        var frequency  		= $('.js--frequency').data('frequency') === 'month' ? '&interval=month' : '';
        var urlValue = `https://donate.schoolsforchildren.org/f1ea?amount=${amount}${frequency}`;
        console.log(urlValue);

        if ( $.trim(amountInput).match(/^[0-9.]+$/) || $.trim(amountButton).match(/^[0-9.]+$/) ) {
            window.location.assign(urlValue);
        }
    });

    // /our-work page, Haiti Kellogg section
    $('#lang-switch').on('change', function(event) {
        const $switch = $(this);
        const $section = $switch.closest('.section');
        
        if( $switch.is(':checked') ) {
            $section.removeClass('lang-english lang-french').addClass('lang-french');
        }
        else {
            $section.removeClass('lang-french lang-english').addClass('lang-english');
        }
    });
    
    $('.j-lang-toggle').on('click', function(event) {
        const lang = $(this).data('lang');
        if( 'french' === lang ) {
            $('#lang-switch').prop('checked', true).trigger('change');
        }
        else {
            $('#lang-switch').prop('checked', false).trigger('change');
        }
    });

}(jQuery));

// Every interval of 'time' check if 'selector' exists
// If 'selector' exists, 'runCode' and stop the timer
// Check 'maxTries' number of times before exiting (set to '-1' to have no limit)
function wait(selector, time, tries, maxTries, runCode) {
    // Creates a true array from any matching elements
    var selectors = [...document.querySelectorAll(selector)];

    // If tries wasn't defined for some reason, set it to 0
    typeof tries === 'undefined' ? tries = 0 : tries = tries;

    // If at least one matching selector is found
    if (selectors.length > 0) {
        selectors.map(function () {
            // Run passed code
            runCode();
        });
    }
    // If no matches were found
    else {
        // Wait 'time' then run code below
        setTimeout(function () {
            // Always restart the timer
            if (maxTries === -1) {
                // Call the timer again
                wait(selector, time, tries, maxTries, runCode);
            }

            // If more tries allowed
            else if (maxTries > tries) {
                // Increment number of tries
                tries++;

                // Start the timer again, passing new 'tries' value
                // This is recommended over using a global variable
                // outside of the 'wait' function to keep count
                wait(selector, time, tries, maxTries, runCode);
            } else {
                return;
            }
        }, time);
    }
}
